<script setup>
const { locale } = useI18n()
const lang = useI18n().locale.value;
const isEn = computed(() => {
  if (locale.value == 'en') {
    return true
  } else {
    return false
  }
})
const isPC = ref(true)
onMounted(() => {
  isPC.value = useDeviceType().value=='pc'
})
</script>

<template>
  <div>
    <div w-full bg-cover h-550 lt-xl:(h-275) bg-center
      :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.banner:stock_trade.cn.m_banner) + ')' }">
      <div mwc relative h-full>
        <div text-left text-white pt-115 mb-99 lt-xl:(pt-64 mb-68) :class="{'mb-40!':isEn}">
          <p text-40 fw l-n mb-37 text-sand lt-xl:(text-18 mb-10) :class="{ 'lt-xl:text-16!': isEn }">{{
            $t('securities_business') }}</p>
          <p titz max-w-500 lt-xl:(text-13 max-w-260)>{{ $t('Invest_in_Hong_Kong_And_US_stocks')}}</p>

        </div>
        <div>
          <!-- <button btn-accent>{{ $t("open_account") }}</button> -->
        </div>
      </div>
    </div>
    <!-- // 投资港美股，开启环球投资新时代 -->
    <div>
      <div w-full bg-cover h-full bg-center bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner1 + ')' }"
        overflow-auto>
        <div class="licensed-broker" h-50 text-36 line-height-50 mt-104 lt-xl:(mt-10  pl-16 pr-16 text-18)>{{ $t('tzgmgkqqqxsd') }}</div>
        <div class="introduce-warp" mt-20 mb-100 lt-xl:(mb-50 mt-10)>
          <div class="introduce-company" w-230 bg-cover h-199 lt-xl:(h-175 w-175) bg-center>
            <div mt-50>
              <div flex justify-center>
                <img w-39 h-42 lt-xl:(w-27 h-31) :src="stock_trade.cn.company1" alt="">
              </div>
              <div text-20 lt-xl:(text-16) class="introduce-title" mt-16 text-center>{{ $t('yzbdmxgs') }}</div>
              <div text-12  class="introduce-content" p-16 text-center>{{ $t('yzbdmxgsjs') }}</div>
            </div>
          </div>
          <div class="introduce-company" w-230 bg-cover h-199 lt-xl:(h-175 w-175) bg-center>
            <div mt-50>
              <div flex justify-center>
                <img w-39 h-42 lt-xl:(w-27 h-31) :src="stock_trade.cn.company2" alt="">
              </div>
              <div text-20 lt-xl:(text-16) class="introduce-title" mt-16 text-center>{{ $t('tzpzdy') }}</div>
              <div text-12 class="introduce-content" p-16 text-center>{{ $t('tzpzdyjs') }}</div>
            </div>
          </div>
          <div class="introduce-company" w-230 bg-cover h-199 lt-xl:(h-175 w-175) bg-center>
            <div mt-50>
              <div flex justify-center>
                <img w-39 h-42 lt-xl:(w-27 h-31) :src="stock_trade.cn.company3" alt="">
              </div>
              <div text-20 lt-xl:(text-16) class="introduce-title" mt-16 text-center>{{ $t('t0lhjy') }}</div>
              <div text-12 class="introduce-content" p-16 text-center>{{ $t('t0lhjyjs') }}</div>
            </div>
          </div>
          <div class="introduce-company" w-230 bg-cover h-199 lt-xl:(h-175 w-175) bg-center>
            <div mt-50>
              <div flex justify-center>
                <img w-39 h-42 lt-xl:(w-27 h-31) :src="stock_trade.cn.company4" alt="">
              </div>
              <div text-20 lt-xl:(text-16) class="introduce-title" mt-16 text-center>{{ $t('zdwsjgyg') }}</div>
              <div text-12 class="introduce-content" p-16 text-center>{{ $t('zdwsjgygjs') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- // 美股的介绍，这里是美股的介绍 -->

    <div pyx lt-xl:(pt-18)>
      <div mwc>
        <div class="stock-market" text-36 lt-xl:(text-18)>{{ $t('mgjs') }}</div>
        <div class="market-content" text-18 mt-24 lt-xl:(text-12)>{{ $t('mgjsnr') }}</div>
        <!-- <div class="market-feature" font-size-36 mt-40>{{ $t('mgts') }}</div> -->
        <ul f-c-b flex-wrap flex-row items-stretch mt-23>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage:  'url(' + (isPC? stock_trade.cn.stock1:stock_trade.cn.m1_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-120 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('qqjjzb') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('qqjjzjs') }}</p>

            </NuxtLink>
          </li>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock2:stock_trade.cn.m2_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-120 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('tzgdxz') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('tzgdxzjs') }}</p>

            </NuxtLink>
          </li>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock3:stock_trade.cn.m3_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-120 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('zjmkjd') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('zjmkjdjs') }}</p>

            </NuxtLink>
          </li>

        </ul>
      </div>
    </div>


    <!-- // 港股的介绍，这里是香港的股票介绍 -->

    <div pyx class="bull-market" lt-xl:(pt-18)>
      <div mwc>
        <div class="stock-market" text-36 lt-xl:(text-18) >{{ $t('gdjs') }}</div>
        <div class="market-content" text-18 mt-24 lt-xl:(text-12)>{{ $t('gdjsnr') }}</div>
        <!-- <div class="market-feature" font-size-36 mt-40>{{ $t('mgts') }}</div> -->
        <ul f-c-b flex-wrap flex-row items-stretch mt-23>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage:  'url(' + (isPC? stock_trade.cn.stock1:stock_trade.cn.m4_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-120 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('ywdjyzkjxf') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('ywdjyzkjxfjs') }}</p>

            </NuxtLink>
          </li>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock2:stock_trade.cn.m5_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-130 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('gdt0jyzd') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('gdt0jyzdjs') }}</p>

            </NuxtLink>
          </li>
          <li class="group" bg-no-repeat
            :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock3:stock_trade.cn.m6_banner) + ')', backgroundSize: 'cover' }"
            bds-palebluishgray px-30 w="32%" h-495 pt-220 pb-44 mb-20 relative hover:(bg-accent text-black) lt-xl:(px-15
            pt-120 h-240 mb-15) lt-xl:w='100%' cp :class="{ 'pt-30!': isEn }">
            <NuxtLink external>
              <p titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('gxaqdtzsc') }}</p>
              <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">{{ $t('gxaqdtzscjs') }}</p>

            </NuxtLink>
          </li>

        </ul>
      </div>
    </div>
    <!-- //沪股通介绍 -->

    <div pyx lt-xl:(pt-18)>
      <div mwc>
        <div class="stock-market" text-36 lt-xl:(text-18)>{{ $t('aghsgt') }}</div>
        <div class="market-content" text-18 mt-24 lt-xl:(text-12)>{{ $t('aghsgtjs') }}</div>
        <!-- <div class="market-feature" font-size-36 mt-40>{{ $t('mgts') }}</div> -->
        <div  bg-contain h-220 mt-24 lt-xl:(h-240 bg-cover)
          :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock5:stock_trade.cn.m7_banner) + ')', backgroundRepeat:'no-repeat' }">
          <div mwc relative h-full lt-xl:(pl-8 pr-8)>
            <div  pt-35 pl-16 mb-20 text-left lt-xl:(pl-0)>
              <p w="50%" font-size-16 titm lt-xl:(mb-0 mt-90 pr-0 text-12 pl-0) lt-xl:w="100%"  :class="{ 'xl:text-16': isEn }">{{ $t('hgtsgtjs') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- // 牛熊证 -->

    <div pyx class="bull-market" lt-xl:(pt-18)>
      <div mwc >
        <div class="stock-market" text-36 lt-xl:(text-18)>{{ $t('nxzjs') }}</div>
        <div class="market-content" text-18 mt-24 lt-xl:(text-12)>{{ $t('nxzjnr') }}</div>
        <!-- <div class="market-feature" font-size-36 mt-40>{{ $t('mgts') }}</div> -->
        <div  bg-contain h-220 mt-24 lt-xl:(h-270 bg-cover)
          :style="{ backgroundImage: 'url(' + (isPC? stock_trade.cn.stock4:stock_trade.cn.m8_banner) + ')', backgroundRepeat:'no-repeat' }">
          <div mwc relative h-full lt-xl:(pl-8 pr-8)>
            <div  pt-35 pl-16  mb-20 text-left t-xl:(pl-0)>
              <p w="55%" font-size-16  titm lt-xl:(mb-0 mt-90 pr-0 text-12 pl-0) lt-xl:w="100%" :class="{ 'xl:text-16': isEn }">{{ $t('nxzdyzyysqz') }}</p>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="lang !== 'cn'" mt-90 w-full bg-cover h-470 bg-center bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner12 + ')' }"
        overflow-auto>

        <div mwc>
          <div class="invest-globally" font-size-36 line-height-50>{{ $t('tzqqjzzj') }}</div>
          <div class="capital-account" font-size-18 line-height-32 mt-30>
            {{ $t('tzqqjzzjjs') }}<span
              class="stock-content"> {{ $t('tzqqjzzjj1') }}</span>{{ $t('tzqqjzzjj3') }}
          </div>
          <ul f-c mb-24 lt-xl:(mb-20 f-c-b) mt-60>
            <li mr-16 lt-xl:mr-0>
              <button btn-inkgray class="more-detail">{{  $t('learn_more') }}</button>
            </li>
            <li mr-16 lt-xl:mr-0>
              <a-popover :overlay-inner-style="{ padding: 0 }">
                <template #content>
                  <a-qrcode error-level="H" value="https://apps.apple.com/hk/app/sptrader-pro-hd/id1043451438"
                    :bordered="false" />
                </template>
                <div f-c cp>
                  <button btn-inkgray>iPhone{{ $t('download') }}</button>
                </div>
              </a-popover>
            </li>
            <li mr-16 lt-xl:mr-0>
              <a-popover :overlay-inner-style="{ padding: 0 }">
                <template #content>
                  <a-qrcode error-level="H"
                    value="https://play.google.com/store/apps/details?id=hk.com.sharppoint.spmobile.sptraderprohd"
                    :bordered="false" />
                </template>
                <div f-c cp>
                  <button btn-inkgray>Android{{ $t('download') }}</button>
                </div>
              </a-popover>

            </li>
            <li>
              <a href="https://spsystem.biz/download/temp/EP/FRT/sptrader_forthright_setup_r87911.zip">
                <button btn-inkgray>PC{{ $t('download') }}</button>
              </a>
            </li>
          </ul>
        </div>


      </div> -->
  </div>
</template>
<style lang="less" scoped>
.licensed-broker {

// height: 3.125rem;
font-family: PingFangSC, PingFang SC;

// font-size: 2.25rem;
color: #1D2228;
// line-height: 3.125rem;
text-align: center;
font-style: normal;
}

.licensed-broker-content {

// height: 1.25rem;
font-family: PingFangSC, PingFang SC;
font-weight: 300;

color: #373B50;

text-align: center;
font-style: normal;
}

.introduce-warp {
display: flex;
flex-wrap: wrap;
align-items: center;
gap: 2rem;
justify-content: center;

}
.introduce-company {
height: 232px;
background: #FFFFFF;
box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
border-radius: 2px;
}
.introduce-title {
font-family: PingFangSC, PingFang SC;
font-weight: 600;

color: #1D2228;
font-style: normal;
}
.introduce-content {

font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #1D2228;


font-style: normal;
}
.stock-market {

font-family: PingFangSC, PingFang SC;
font-weight: 600;

color: #333333;

text-align: left;
font-style: normal;
}
.market-content {

font-family: PingFangSC, PingFang SC;
font-weight: 400;

color: #333333;

text-align: left;
font-style: normal;
}
.market-feature{

font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 36px;
color: #333333;
text-align: left;
font-style: normal;
}
.invest-globally {

font-family: PingFangSC, PingFang SC;
font-weight: 600;

color: #504137;


font-style: normal;
}

.capital-account {

font-family: PingFangSC, PingFang SC;
font-weight: 400;

color: #333333;

text-align: left;
font-style: normal;
}

.more-detail {
border: 1px solid #AA7322;
color: #AA7322;
// line-height: 38px;
background-color: #ffffff;
}
.bull-market {
  background: #F9F9FA;
}
</style>
